import RouterManagement from "./router/RouterManagment";

const App = () => {
	return <RouterManagement />;
};

export default App;
